<template>
  <b-container>
    <b-row align-h="center">
      <b-col cols="6">
        <b-card>
          <b-form v-on:submit.prevent enctype="multipart/form-data">
            <b-row>
              <b-col>
                <b-form-group label="Purchase Code" label-for="purchase">
                  <v-select
                    id="purchase"
                    v-model="form.selectedPurchase"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsPurchase"
                    placeholder="Select 1 Purchase"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedPurchase"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedPurchase }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Amount" label-for="amount">
                  <cleave
                    id="amount"
                    placeholder="Amount"
                    v-model="form.amount"
                    class="form-control"
                    :raw="false"
                    :options="options.number"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Type" label-for="type">
                  <v-select
                    id="type"
                    v-model="form.selectedType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsType"
                    placeholder="Select 1 Type"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedType"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedType }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mt-1"
              @click="validation()"
            >
              Submit
            </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BFormTextarea,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        selectedPurchase: null,
        optionsPurchase: [],
        amount: null,
        selectedType: null,
        optionsType: [
          { value: 1, text: "Full Payment" },
          { value: 2, text: "Down Payment" },
        ],
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      errors: "",
      errMessage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-success",
        2: "light-primary",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getPurchase();
  },
  methods: {
    getPurchase() {
      this.$http.get("procurement/purchases").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].code,
          };
          // console.log($data)
          this.form.optionsPurchase.push($data);
        }
        // console.log(this.form.optionsPurchase)
      });
    },
    validation() {
      if (this.form.selectedPurchase === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Purchase field is required",
            variant: "warning",
          },
        });
      } else if (this.form.amount === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Amount field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedType === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Type field is required",
            variant: "warning",
          },
        });
      } else {
        this.addPayment();
      }
    },
    addPayment() {
      if (this.form.selectedPurchase !== null) {
        var $PurchaseID = this.form.selectedPurchase.value;
      }
      var newAmount = this.form.amount;
      newAmount = newAmount.replace(/\,/g, "");
      if (this.form.selectedType !== null) {
        var $TypeID = this.form.selectedType.value;
      }
      this.$http
        .post("procurement/payment/add", {
          purchase_id: $PurchaseID,
          amount: newAmount,
          type: $TypeID,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success add Payment",
              variant: "success",
            },
          });
          location.href = "/procurement/procurement-payment";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>